import React from "react"
import { useDropzone } from "react-dropzone";
import { Typography } from "@material-ui/core";

const filetypes = {
    "application/pdf": "PDF",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPT",
    "application/vnd.ms-excel": "XLS",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
    "application/msword": "DOC",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
    "application/vnd.ms-outlook": "Outlook Email",
    "text/csv": "CSV",
    "text/plain": "TXT",
}

const defaultDropAreaStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "100px",
    paddingBottom: "100px",
    borderWidth: 2,
    borderRadius: 25,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    color: "#FFFFFF",
    transition: "border .3s ease-in-out"
}

const FileDropArea = ({ files = {}, setFiles, ...others }) => {
    const accept = others.accept
    const validator = others.validator
    const fileAcceptCount = others.maxFiles !== undefined ? others.maxFiles : 0
    const overrideStyles = others.overrideStyles !== undefined ? others.overrideStyles : false
    const dropAreaProps = overrideStyles ? others.style !== undefined ? others.style : defaultDropAreaStyle : defaultDropAreaStyle
    const dropAreaText = others.dropAreaText !== undefined ? others.dropAreaText : "Drag and drop your files here or Click here"
    const typographyProps = { variant: "h5", color: "textSecondary", ...(others.typographyProps !== undefined ? { ...others.typographyProps } : {}) }

    const onFileDrop = (acceptedFiles, fileRejections, event) => {
        acceptedFiles.map((file) => Object.assign(file, { filetype: filetypes[file.type] }))
        var droppedFiles = { ...files }
        acceptedFiles.map((file) => { droppedFiles = { ...droppedFiles, [file.name]: { file, format: "NOVAL", error: null } } })
        setFiles(droppedFiles);
    }

    const { isDragActive, isDragAccept, isDragReject, getRootProps, getInputProps } = useDropzone({ ...(accept !== undefined ? { accept: accept } : {}), ...(validator !== undefined ? { validator: validator } : {}), maxFiles: fileAcceptCount, onDrop: onFileDrop })

    const style = React.useMemo(() => ({ ...dropAreaProps, ...(isDragActive ? { borderColor: "#2196f3" } : {}), ...(isDragAccept ? { borderColor: "#00e676" } : {}), ...(isDragReject ? { borderColor: "#ff1744" } : {}) }), [isDragActive, isDragReject, isDragAccept]);

    return (
        <div {...getRootProps({ style })}>
            <Typography {...typographyProps}>{dropAreaText}</Typography>
            <input {...getInputProps()} />
        </div>
    )
}

export default FileDropArea
